function getDiscountPrice(imageInfo) {
  const { price, dcRt, dcPrc, originalPrice } = imageInfo;
  if (imageInfo.priceType === 'SALE') {
    return dcRt > 0 ? dcPrc : originalPrice; // dcPrc = 티몬가
  }
  return price;
}

function ItemTitle(imageInfo, optionOrder) {
  const no = optionOrder + 1;
  const title = imageInfo.optionTitle.split('|')[0];
  return `<div class="tmde-opt-info">
    <strong class="tmde-opt-label">${no}</strong>
    <cite class="tmde-opt-subject">
      ${imageInfo.isBundleOnly ? '<strong class="addoption">[추가구매상품]</strong>' : ''}
      ${title}
    </cite>
  </div>`;
}

function DiscountPriceWithRate(imageInfo) {
  const { dcRt, originalPrice } = imageInfo;
  const discountPrice = getDiscountPrice(imageInfo);
  return `<div class="tmde-spot-discount tmde-spot-per">
    <span class="tmde-spot">
      <span class="tmde-figure">${dcRt}</span>%
    </span>
    <span class="tmde-spot-price">
      <span class="tmde-add-spot">
        <span class="line"></span>
        <em class="tmde-figure">${TMON.util.numberFormat(originalPrice)}</em>원
      </span>
      <em class="tmde-add-spot-price">
        <em class="tmde-figure">${TMON.util.numberFormat(discountPrice)}</em>원
      </em>
    </span>
  </div>`;
}

function DiscountPrice(imageInfo) {
  const price = TMON.util.numberFormat(getDiscountPrice(imageInfo));
  return `<div class="tmde-spot-discount tmde-spot-tmon">
    <span class="tmde-spot">판매가</span>
    <span class="tmde-spot-price">
      <em class="tmde-add-spot-price">
        <em class="tmde-figure">${price}</em>원
      </em>
    </span>
  </div>`;
}

function ImmediatelyDiscountPrice(imageInfo) {
  if (imageInfo.priceType !== 'SALE') return '';
  const price = TMON.util.numberFormat(imageInfo.price);
  return `<div class="tmde-spo-discout-wrap">
    <span class="tmde-spot-discount">
      <span class="tmde-spot" style="min-width:70px">즉시할인가</span>
      <span class="tmde-spot-price">
          <em class="tmde-figure">${price}</em>원
      </span>
    </span>
  </div>`;
}

function Price(imageInfo, viewPrice) {
  if (viewPrice !== 'Y') return '';
  const { priceType, dcRt } = imageInfo;
  const isRate = priceType === 'RATE' || dcRt > 0;
  const Dicount = isRate ? DiscountPriceWithRate(imageInfo) : DiscountPrice(imageInfo);
  const Immediately = ImmediatelyDiscountPrice(imageInfo);
  return `<div>${Dicount}${Immediately}</div>`;
}

const SummaryTop = (imageInfo, optionOrder, viewPrice) => {
  return `<div class="tmde-review">
    <div class="inr">
      <div>
        ${ItemTitle(imageInfo, optionOrder)}
        ${Price(imageInfo, viewPrice)}
      </div>
    </div>
  </div>`;
};

export default SummaryTop;
